import { unitToMinutes, minutesToUnit } from "../../utilities/dateUtilities"
import { NumberInputWithCategory } from "./numberInputWithCategory"
import Enums from "../../utilities/enum"

export const MinutesInputWithUnit = ({ numberOfMinutes, handleChange }) => {
    const durationOptions = Object.entries(Enums.TimeSpanMode).filter(([key, value]) => key < 3).map(item => ({ key: Number(item[0]), value: item[1] }))
    const { value: inputValue, unit: inputKey } = minutesToUnit(numberOfMinutes)
    
    return (
        <NumberInputWithCategory
            options={ durationOptions }
            inputValueAndCategory={ {
                key: inputKey,
                value: inputValue
            } }
            onChange={ (k, v) => handleChange(unitToMinutes(v, k)) }
        />
    )
}